module.exports = __webpack_public_path__ + "img/Logo_blu_1000.894c98b6.png";